import React from "react";
import { defineMessages } from "react-intl";
import { MemoizedChip } from "../../../components/chip/ChipRenderer.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import "@mui/material";
import "../../../components/icons/Icon.js";
import "../../../components/icons/ExpandMoreIcon.js";
import { EmptyLabel } from "../../../components/label/EmptyLabel.js";
import "../../../components/label/LabelHoc.js";
import { FeatureAccessStatusTypeName } from "../../../contract/constants.js";
import "@automapper/core";
import { PlayerGlobalSettingsLink } from "../../p2p-player-settings/components/PlayerGlobalSettingsLink.js";
import "../../p2p-player-settings/components/PlayerGlobalSettings.js";
import "../../../auto-mapper/AutoMapperProvider.js";
import "typesafe-actions";
import "normalizr";
import "rxjs";
import "rxjs/operators";
import "../../../api/types.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../../otel/TraceProvider.js";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "redux-observable";
import "../../../redux-folder/async-action/action.js";
import "../../../redux-folder/error-handling/action.js";
import "../../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../../redux-folder/entity/epics.js";
import "../../../redux-folder/entity/EntityProvider.js";
import "reselect";
import "react-redux";
import "react-router";
import "../../../redux-folder/realtime/RealtimeNotification.js";
const localized = defineMessages({
  linkLabel: {
    id: "P2PStatusCell_global",
    defaultMessage: "Global"
  },
  modalTitle: {
    id: "P2PStatusCell_modalTitle",
    defaultMessage: "Global P2P Settings"
  }
});
function P2PStatusCell({ type, personalLockStatus, uid, entityType }) {
  return type === "Personal" ? /* @__PURE__ */ React.createElement(MemoizedChip, { value: personalLockStatus, chipName: FeatureAccessStatusTypeName }) : entityType && uid ? /* @__PURE__ */ React.createElement(
    PlayerGlobalSettingsLink,
    {
      uid,
      label: localized.linkLabel,
      modalTitle: localized.modalTitle,
      entityType,
      mode: "only-lock-status"
    }
  ) : /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" });
}
function renderP2PStatusCell(params) {
  const { type, personalLockStatus, uid, entityType } = params.value;
  return /* @__PURE__ */ React.createElement(P2PStatusCell, { type, personalLockStatus, uid, entityType });
}
export {
  P2PStatusCell,
  renderP2PStatusCell
};
//# sourceMappingURL=P2PStatusCell.js.map
